module.exports = __webpack_public_path__ + "static/media/go-back-left-arrow.82c50ec8.svg";